
import Vue from 'vue';

export default Vue.extend({
    name: 'Poll',

    props: {
        text: {
            type: String,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false
        },
        showRadioButton: {
            type: Boolean,
            default: false
        },
        showCheckBox: {
            type: Boolean,
            default: false
        },
        disableUnselected: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        disabled():boolean {
            return this.disableUnselected && !this.selected;
        }
    },

    methods: {
        onClick(event:Event) {
            if (this.disabled) {
                return;
            }
            this.$emit('click', event);
        }
    }
});
